import React, { useEffect, useState } from "react";
import "../css/dashboard.scss";
import Header from "../components/header/Header";
import { getPartnerFilms } from "../services/partner";

// Film views dashboard — backed by GET /api/partner/stats/films.
// Same backing data as the main Dashboard; this view trims the column set to
// the views-centric numbers. The legacy `.xlsx` report endpoint
// (/partner/report/film/:id) was not ported to the Go backend and the
// download button has been removed.
const ViewDashboard = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    getPartnerFilms().then((res) => {
      setData(res.data.data || []);
    });
  }, []);

  return (
    <div className="box">
      <Header />
      <div className="filter"></div>
      <div className="all-center">
        <div className="box-table">
          <table>
            <tbody>
              <tr className="text-center">
                <th>IMAGE</th>
                <th>NAME</th>
                <th>PRICE FOR VIEW</th>
                <th>VIEWS COUNT</th>
                <th>PARTNER'S PAYMENT</th>
              </tr>

              {data.map((row) => (
                <tr key={row.content_id}>
                  <td>
                    <img
                      width={60}
                      src={"https://media.metaflix.az/" + row.main_picture}
                      alt=""
                    />
                  </td>
                  <td>{row.name}</td>
                  <td>{row.cash} AZN </td>
                  <td>{row.hit}</td>
                  <td>{row.part} AZN</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ViewDashboard;
